import { instance as axios } from "../axios";
import JWT from 'jsonwebtoken';

import {PRIVATE, PUBLIC} from '../variables'

const TABLE = '/escritorio/';

// initial state
const state = {
    data: []
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data;
    },
    getById: (state) => (id) => {
        if(!id) return;
        return state.data.find((el)=>{ return el.id_escritorio == id})
    },
}

// actions
const actions = {

    get({ commit }) {
        return axios
            .get(TABLE)
            .then(res => {
                decode(res.data.data).then((r)=>{
                    if(r) commit('setData', r)
                    else commit('setData', null)
                });
            })
            .catch(err => {
                commit('setData', null)
            });
    },

    insert({ dispatch }, params) {
        
        return axios
            .post(TABLE+token(params))
            .then(res => {
                if(!res.data.errors) {
                    dispatch('get');
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

    update({ dispatch }, params) {
        return axios
            .put(TABLE+token(params))
            .then(res => {
                if(!res.data.errors) {
                    dispatch('get');
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

    delete({ dispatch }, params) {
        return axios
            .delete(TABLE+token(params))
            .then(res => {
                if(!res.data.errors){
                    dispatch('get');
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

}

// mutations
const mutations = {
    setData(state, data) {
        state.data = data ? data : [];
    }
}

function token(params) {
    return JWT.sign({
        exp: Math.floor(Date.now() / 1000) + (60),
        data: params
    }, PRIVATE, { algorithm: 'RS256'});
}

function decode (token) {
    return new Promise(
        function (resolve, reject) {
          JWT.verify(token, PUBLIC, (err, decoded) => {
            if(err)resolve(false);
            else resolve(JWT.decode(token).data);
          });
        }
    );
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/escritorios.js